import React from 'react';
import { useTranslation } from 'react-i18next';
import { Check, LayoutGrid } from 'lucide-react';
import { useAppearance } from '../../theme/ThemeContext';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';

export default function DisplayModeSettingCard() {
  const { t } = useTranslation('settings');
  const { displayMode, changeDisplayMode, displayModeSaved, displayModeOptions } = useAppearance();

  return (
    <Card className="bg-card border-border" data-testid="display-mode-setting">
      <CardHeader className="pb-3">
        <CardTitle className="flex items-center gap-2 text-base">
          <LayoutGrid className="h-4 w-4 text-primary" aria-hidden="true" />
          {t('display_mode.heading')}
        </CardTitle>
        <p id="display-mode-description" className="text-sm text-muted-foreground">
          {t('display_mode.description')}
        </p>
      </CardHeader>
      <CardContent className="space-y-3">
        <fieldset aria-describedby="display-mode-description">
          <legend className="sr-only">{t('display_mode.heading')}</legend>
          <div className="tn-display-options" data-option-count={displayModeOptions.length}>
            {displayModeOptions.map(mode => (
              <label key={mode} className="tn-display-option">
                <input
                  type="radio"
                  name="trainnova-display-mode"
                  value={mode}
                  checked={displayMode === mode}
                  onChange={() => changeDisplayMode(mode)}
                  className="peer sr-only"
                  data-testid={`display-mode-${mode}`}
                />
                <span className="tn-display-option__body">
                  <span className="flex min-w-0 items-center justify-between gap-2 font-semibold">
                    {t(`display_mode.${mode}`)}
                    <Check className={`h-4 w-4 shrink-0 ${displayMode === mode ? '' : 'invisible'}`} aria-hidden="true" />
                  </span>
                  <span className="block mt-1 text-sm text-muted-foreground">{t(`display_mode.${mode}_description`)}</span>
                </span>
              </label>
            ))}
          </div>
        </fieldset>
        <p className="text-xs text-muted-foreground">{t('display_mode.device_hint')}</p>
        <p role="status" className="text-sm text-muted-foreground empty:hidden">
          {!displayModeSaved && t('display_mode.storage_unavailable')}
        </p>
      </CardContent>
    </Card>
  );
}
